import { LayoutElement, isLayoutTableFieldElement } from "@entaconsulting/form";
import useColumnEdited from "developer/edit/hooks/useColumnEdited";
import getColumnPointingName from "developer/edit/utils/getColumnPointingName";
import React from "react";
import { Field, FieldProps, useField } from "react-final-form";

const DynamicField: React.FC<FieldProps<any, any>> = ({ name, ...rest }) => {
  const {
    input: { value: rootElement },
  } = useField<LayoutElement>("element");

  const columnEdited = useColumnEdited();

  const newPointingName =
    columnEdited && isLayoutTableFieldElement(rootElement)
      ? getColumnPointingName(name, columnEdited)
      : name;

  const fieldProps = {
    ...rest,
    name: newPointingName,
  };

  return <Field {...fieldProps} />;
};

export default DynamicField;
